import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  smallLayout: boolean | undefined;
};

export const Container = styled.div<Props>(
  ({theme, smallLayout}) => css`
    border: 1px solid ${theme.colors.borderSecondary};
    border-radius: 5px;
    display: flex;
    justify-content: center;

    padding: 8px 24px;
    gap: 32px;
    flex-direction: row;
    align-items: center;

    button {
      width: auto;
    }

    ${smallLayout &&
    css`
      padding: 12px;
      gap: 8px;
      flex-direction: column;
      align-items: stretch;

      button {
        width: 100%;
      }
    `};

    svg {
      flex: 0 0 100px;
    }
  `
);
